import React from "react";

const AnalyticsContext = React.createContext<any | null>(null);

export default AnalyticsContext;
